import React from 'react';
import { useApp } from '../../context/AppContext.tsx';

interface AdBannerSlotProps {
  position?: 'top' | 'sidebar' | 'in_article' | 'bottom';
}

export default function AdBannerSlot({ position = 'bottom' }: AdBannerSlotProps) {
  const { ads } = useApp();

  const ad = ads.find((a) => a.position === position && a.enabled);

  if (!ad) return null;

  return (
    <section className="py-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative rounded-2xl overflow-hidden border border-slate-200 shadow-xs bg-slate-900 group">
        <a
          href={ad.targetUrl || '#'}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          {ad.type === 'image' && ad.imageUrl ? (
            <img
              src={ad.imageUrl}
              alt={ad.title}
              className="w-full max-h-48 md:max-h-60 object-cover object-center group-hover:scale-101 transition-transform"
            />
          ) : (
            <div
              className="p-6 text-center text-white"
              dangerouslySetInnerHTML={{ __html: ad.scriptContent || '' }}
            />
          )}
          <span className="absolute bottom-2 right-2 bg-black/60 backdrop-blur-xs text-white text-[9px] px-2 py-0.5 rounded-sm font-semibold">
            Iklan Mitra / Ads
          </span>
        </a>
      </div>
    </section>
  );
}
